import { Skeleton } from "../ui/skeleton";

export default function AutoStackPerformanceChartSkeleton() {
  return (
    <div className="bg-white rounded-lg p-4">
      <div className="flex justify-between items-center mb-2">
        <Skeleton className="h-5 w-40 bg-gray-300" />
        <Skeleton className="h-4 w-20 bg-gray-300" />
      </div>

      <div className="space-y-2 mb-2">
        <Skeleton className="h-8 w-48 bg-gray-300" />
        <Skeleton className="h-5 w-32 bg-gray-300" />
      </div>

      <Skeleton className="h-48 autostack-performance-chart-skeleton w-full rounded-lg bg-gray-300" />
    </div>
  );
}
